import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import { paymentGatewayOptions, stripeInfo } from '../../../server/constants'
import { getPaymentGateway, groupBy, getSchoolCountryCode } from '../../../server/util';
import PaymobPay from './paymob/paymobPay';
import UnionPay from './unionPay';
import Stripe3DCheckOut from './stripe/stripe3DCheckOut';
import StripeCheckOut from './stripe/stripeCheckOut';
import PayMaya from './paymaya';
const customStyles = {
    content: {
        textAlign: 'justify',
        textJustify: 'inter-word',
        padding: '0px',
        height: '450px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    },
    upayContent: {
        textAlign: 'justify',
        textJustify: 'inter-word',
        padding: '0px',
        height: '450px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '60%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
}

class PaymentModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPayMobModal: false,
            showStripe3DModal: false,
            showUnionPayModal: false
        }
    }
    addStripeLib = () => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.id = "stripe-js";
        script.async = true;
        const isLoaded = Boolean(document.querySelector('script[src="' + script.src + '"]'));
        if (!isLoaded) {
            document.body.appendChild(script);
        }
    }
    getPayMobDetails = (gateWayOption) => {
        const groupGateWay = groupBy(gateWayOption.formValues || [], 'name');
        let iframeURL = '';
        let apiKey = '';
        let integrationId = '';
        if (((groupGateWay || {}).iframeURL || []).length > 0) {
            iframeURL = ((groupGateWay || {}).iframeURL || [])[0].value || '';
        }
        if (((groupGateWay || {}).apiKey || []).length > 0) {
            apiKey = ((groupGateWay || {}).apiKey || [])[0].value || '';
        }
        if (((groupGateWay || {}).integrationId || []).length > 0) {
            integrationId = ((groupGateWay || {}).integrationId || [])[0].value || '';
        }
        return {
            iframeURL: iframeURL,
            apiKey: apiKey,
            integrationId: integrationId,
        }
    }
    renderPaymentGateWay = () => {
        const { schoolId } = this.props;
        const gateWayOption = getPaymentGateway(schoolId || 0);
        switch (gateWayOption.payGatewayName) {
            case paymentGatewayOptions.STRIPE:
                /*  return (getSchoolCountryCode(schoolId)==='US'?<StripeCheckOut {...this.props} />:
                 <Fragment>{this.addStripeLib()}
                 <button className="btn btn-success" onClick={(e)=>{
                     this.setState({showStripe3DModal:true})
                 }}>Pay With Card</button>
                </Fragment>); */
                return (
                    <Fragment>{this.addStripeLib()}
                        <button className="btn btn-success" onClick={(e) => {
                            this.setState({ showStripe3DModal: true })
                        }}>Pay With Card</button>
                    </Fragment>);

            case paymentGatewayOptions.PAYMOB:
                return <button className="btn btn-success" onClick={(e) => {
                    this.setState({ showPayMobModal: true })
                }}>Pay With Card</button>
            case paymentGatewayOptions.UNIONPAY:
                return <UnionPay {...this.props} {...gateWayOption} />
            case paymentGatewayOptions.PAYMAYA:
                return <PayMaya {...this.props} {...gateWayOption} />

            default:
                return null;
        }
    }
    render() {
        const { schoolId } = this.props;
        const gateWayOption = getPaymentGateway(schoolId || 0);
        const payMobObj = this.getPayMobDetails(gateWayOption);

        return (
            <Fragment>
                {
                    this.renderPaymentGateWay()
                }
                <Modal
                    isOpen={this.state.showStripe3DModal}
                    style={customStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div class="modal-header">
                        <h5 class="modal-title" style={{ display: 'inline' }}>Stripe Payment</h5>
                        <span style={{ color: '#aaa', float: 'right', fontSize: '28px', fontWeight: 'bold', cursor: 'pointer' }}
                            onClick={() => {
                                this.setState({ showStripe3DModal: false })
                            }}>&times;</span>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <Stripe3DCheckOut {...this.props} />
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.showPayMobModal}
                    style={customStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <span style={{ color: '#aaa', float: 'right', fontSize: '28px', fontWeight: 'bold' }}
                                    onClick={() => {
                                        this.setState({ showPayMobModal: false })
                                    }}>&times;</span>
                                <PaymobPay {...this.props}
                                    iframeUrl={`${payMobObj.iframeURL}`}
                                    apiKey={payMobObj.apiKey}
                                    integrationId={payMobObj.integrationId}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </Fragment>
        )
    }
}
export default PaymentModule


// WEBPACK FOOTER //
// ./src/components/Misc/PaymentModule/index.js